// Pure formatting helpers for the analyst UI — A5.
//
// Extracted from ArtifactCard so they can be unit-tested without
// pulling React testing infrastructure into the project. The rendering
// components depend on these; the components themselves are exercised
// at typecheck time (npm run typecheck / tsc --noEmit) and visually
// in dev — adding @testing-library/react is a separate concern.

/** Format a single Frame cell for display. Nulls render as an em-dash,
 *  numbers as ``formatNumber``, everything else as ``String(v)``. */
export function formatCell(v: unknown): string {
  if (v === null || v === undefined) return "—";
  if (typeof v === "number") return formatNumber(v);
  return String(v);
}

/** Format a number for display. Locale-grouped at >= 1000, exact for
 *  integers, two decimal places otherwise. NaN / Infinity pass through
 *  via ``String(n)`` so the user sees the raw value rather than a
 *  silently-mangled rendering. */
export function formatNumber(n: number): string {
  if (!Number.isFinite(n)) return String(n);
  if (Math.abs(n) >= 1000) return n.toLocaleString();
  if (Number.isInteger(n)) return String(n);
  return n.toFixed(2);
}

/** Human-readable label for an artifact kind. Replaces underscores
 *  with spaces; rendering is otherwise unchanged. */
export function kindLabel(kind: string): string {
  return kind.replace(/_/g, " ");
}
